import { render, staticRenderFns } from "./nbHandleHis.vue?vue&type=template&id=0e8acf56&scoped=true"
import script from "./nbHandleHis.vue?vue&type=script&lang=js"
export * from "./nbHandleHis.vue?vue&type=script&lang=js"
import style0 from "./nbHandleHis.vue?vue&type=style&index=0&id=0e8acf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8acf56",
  null
  
)

export default component.exports